module.exports = __webpack_public_path__ + "img/zhangwenji.cf65179f.jpg";